export const mergeCallbacks = (...callbacks) => {
    return (...args) => {
        callbacks.forEach((func) => func === null || func === void 0 ? void 0 : func(...args));
    };
};
//# sourceMappingURL=mergeCallbacks.js.map